import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 6h12","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M4 18h12","key":"svg-2"}]]

const IconClearAll = createReactComponent('outline', 'clear-all', 'ClearAll', __iconNode);

export default IconClearAll;